module.exports = __webpack_public_path__ + "img/t4.8f2cc614.svg";